import api from '@/api';

export default {
    namespaced: true,

    state: {
        accounts: [],
    },

    actions: {

        async fetchAccounts(context, obj) {
            let url = `/admin/deletions?page=${obj.page}`;
            try {
                const response = await api.request('get', url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async approveRequest(context, item) {
            let url = `/admin/deletions/${item.uid}`;
            let body = {}
            try {
                const response = await api.request('put', url, body);
                if (response.data.success) {
                    context.commit('spliceAccount', item)
                }
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async declineRequest(context, item) {
            let url = `/admin/deletions/${item.uid}`;
            try {
                const response = await api.request('delete', url);
                if (response.data.success) {
                    context.commit('spliceAccount', item)
                }
                return response.data;
            } catch (error) {
                throw error;
            }
        },

    },
    mutations: {
        spliceAccount(state, accounts) {
            const index = state.accounts.findIndex(item => item === accounts)
            state.accounts.splice(index, 1)
        },

    }
};
